export default __webpack_public_path__ + "css/delivery.bundle.css";